module.exports = __webpack_public_path__ + "img/about.68c7c61c.jpg";